import CalendarLocale from '../../rc-components/calendar/locale/nb_NO';
import TimePickerLocale from '../../time-picker/locale/nb_NO';
// Merge into a locale object
const locale = {
    lang: {
        placeholder: 'Velg dato',
        rangePlaceholder: ['Startdato', 'Sluttdato'],
        ...CalendarLocale,
    },
    timePickerLocale: {
        ...TimePickerLocale,
    },
};
// All settings at:
export default locale;
